import { useNavigate } from "react-router-dom";

/**
 * footer
 */
function Footer() {
    let navigate = useNavigate(); // Replaces useHistory

    function pushHistory(push_path){
        navigate(push_path); // Replaces history.push
    }

    return (
        <div className="col-12 justify-content-center d-flex flex-row">                 
            <p className="mb-0 pb-0 pt-1" style={{fontSize:"10px"}}>Kopierrecht © 2021 - Mosterei Kiefer - {"       "} 
            <a href="" onClick={(e) => {e.preventDefault(); navigate("/impressum")}}>
            Impressum
            </a>
              -  
            <a href="" onClick={(e) => {e.preventDefault(); navigate("/datenschutz")}}>
            Datenschutz
            </a>
              </p>
            
        </div>
    );
}

export default Footer;
